// アコーディオン
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + 'px';
  el.offsetHeight;
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.transitionTimingFunction = 'ease';
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = 'none';
    el.style.removeProperty('height');
    el.style.removeProperty('padding-top');
    el.style.removeProperty('padding-bottom');
    el.style.removeProperty('margin-top');
    el.style.removeProperty('margin-bottom');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-timing-function');
    el.classList.remove('is-open');
  }, duration);
};

const slideDown = (el, duration = 300) => {
  el.classList.add('is-open');
  el.style.removeProperty('display');
  let display = window.getComputedStyle(el).display;
  if (display === 'none') {
    display = 'flex';
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = 'hidden';
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = 'height, margin, padding';
  el.style.transitionDuration = duration + 'ms';
  el.style.transitionTimingFunction = 'ease';
  el.style.height = height + 'px';
  el.style.removeProperty('padding-top');
  el.style.removeProperty('padding-bottom');
  el.style.removeProperty('margin-top');
  el.style.removeProperty('margin-bottom');
  setTimeout(() => {
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
    el.style.removeProperty('transition-duration');
    el.style.removeProperty('transition-property');
    el.style.removeProperty('transition-timing-function');
  }, duration);
};

const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === 'none') {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
};

const accordions = document.querySelectorAll('[data-accordion]');
const accordionsArr = Array.prototype.slice.call(accordions);

accordionsArr.forEach((accordion) => {
  const accordionTriggers = accordion.querySelectorAll('[data-accordion-trigger]');
  const accordionTriggersArr = Array.prototype.slice.call(accordionTriggers);

  accordionTriggersArr.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      trigger.classList.toggle('is-active');
      const content = trigger.nextElementSibling;
      slideToggle(content);
    });
  });
});
if(location.hash) {
  const urlParams = location.hash
  const target = document.querySelector(urlParams)

  target.querySelector('[data-accordion-trigger]').classList.toggle('is-active');
  const content = target.querySelector('.sizeguide-content');
  slideDown(content, 0);
}
const ankerLinkArr = document.querySelectorAll('[data-sizeguide-link]')
Array.from(ankerLinkArr).forEach(value => {
  value.addEventListener('click', () => {
    const index = value.href.indexOf('#')
    const targetId = value.href.slice(index)

    const target = document.querySelector(targetId)

    target.querySelector('[data-accordion-trigger]').classList.toggle('is-active');
    const content = target.querySelector('.sizeguide-content');
    slideDown(content, 0);
  })
})


// サイズ切り替え
const unitArr = document.querySelectorAll('[data-change-unit]')
unitArr.forEach(value => {
  value.addEventListener('click', () => {
    let current = value
    const unitCm = value.parentElement.nextElementSibling.querySelectorAll('[data-cm]')
    value.classList.toggle('active')
    console.log(current.dataset.changeUnit);

    if(current.dataset.changeUnit == 'cm') {
      console.log('inch');
      current.dataset.changeUnit = 'inch'
      unitCm.forEach(value => {
        value.innerHTML = value.dataset.inch
      })
    } else {
      console.log('cm');
      current.dataset.changeUnit = 'cm'
      unitCm.forEach(value => {
        value.innerHTML = value.dataset.cm
      })
    }
  })
})

// タブ切り替え
const tabArr = document.querySelectorAll('[data-tab]')
tabArr.forEach((value) => {
  const targetValue = value.querySelectorAll('li')
  targetValue.forEach((target, index) => {
    target.addEventListener('click', () => {
      targetValue.forEach(value => {
        value.classList.remove('active')
      })
      Array.from(value.nextElementSibling.children).forEach(value => {
        value.classList.remove('active')
      })
      target.classList.add('active')
      value.nextElementSibling.children[index].classList.add('active')
    })
  })
})

// SPメニュー
const menuBtn = document.querySelector('[data-sizeguide-icon]')
const menu = document.querySelector('[data-sizeguide-popup]')
const menuClose = document.querySelector('[data-sizeguide-close]')

document.addEventListener('click', (e) => {
  if(!e.target.closest('[data-sizeguide-icon]')) {
    menu.classList.remove('active')
  } 
  else {
    menu.classList.add('active')
  }
})